/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpageback2Inputs */

const en_ticketpageback2 = /** @type {(inputs: Ticketpageback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to earnings`)
};

const de_ticketpageback2 = /** @type {(inputs: Ticketpageback2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zu den Einnahmen`)
};

/**
* | output |
* | --- |
* | "Back to earnings" |
*
* @param {Ticketpageback2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpageback2 = /** @type {((inputs?: Ticketpageback2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpageback2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpageback2(inputs)
	return de_ticketpageback2(inputs)
});
export { ticketpageback2 as "ticketPageBack" }